import _toConsumableArray from "/home/runner/work/3/3/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import * as React from "react";
import { cleanup } from "../../utils.js";
import { useEventCallback } from "../../hooks/useEventCallback.js";
import { EVENT_ON_POINTER_CANCEL, EVENT_ON_POINTER_DOWN, EVENT_ON_POINTER_LEAVE, EVENT_ON_POINTER_MOVE, EVENT_ON_POINTER_UP } from "../../consts.js";
export var usePointerSwipe = function usePointerSwipe(subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
  var offset = React.useRef(0);
  var pointers = React.useRef([]);
  var activePointer = React.useRef();
  var startTime = React.useRef(0);
  var clearPointer = React.useCallback(function (event) {
    if (activePointer.current === event.pointerId) {
      activePointer.current = undefined;
    }

    var currentPointers = pointers.current;
    currentPointers.splice.apply(currentPointers, [0, currentPointers.length].concat(_toConsumableArray(currentPointers.filter(function (p) {
      return p.pointerId !== event.pointerId;
    }))));
  }, []);
  var addPointer = React.useCallback(function (event) {
    clearPointer(event);
    pointers.current.push(event);
  }, [clearPointer]);
  var onPointerDown = useEventCallback(function (event) {
    addPointer(event);
  });
  var onPointerUp = useEventCallback(function (event) {
    if (pointers.current.find(function (x) {
      return x.pointerId === event.pointerId;
    }) && activePointer.current === event.pointerId) {
      var duration = Date.now() - startTime.current;
      var currentOffset = offset.current;

      if (Math.abs(currentOffset) > 0.3 * containerWidth || Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration) {
        onSwipeFinish(currentOffset, duration);
      } else {
        onSwipeCancel(currentOffset);
      }

      offset.current = 0;
    }

    clearPointer(event);
  });
  var onPointerMove = useEventCallback(function (event) {
    var pointer = pointers.current.find(function (p) {
      return p.pointerId === event.pointerId;
    });

    if (pointer) {
      var deltaX = event.clientX - pointer.clientX;
      var deltaY = event.clientY - pointer.clientY;

      if (!activePointer.current && isSwipeValid(deltaX) && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 30) {
        addPointer(event);
        activePointer.current = event.pointerId;
        startTime.current = Date.now();
        onSwipeStart();
      } else if (activePointer.current === event.pointerId) {
        offset.current = deltaX;
        onSwipeProgress(deltaX);
      }
    }
  });
  React.useEffect(function () {
    return cleanup(subscribeSensors(EVENT_ON_POINTER_DOWN, onPointerDown), subscribeSensors(EVENT_ON_POINTER_MOVE, onPointerMove), subscribeSensors(EVENT_ON_POINTER_UP, onPointerUp), subscribeSensors(EVENT_ON_POINTER_LEAVE, onPointerUp), subscribeSensors(EVENT_ON_POINTER_CANCEL, onPointerUp));
  }, [subscribeSensors, onPointerDown, onPointerMove, onPointerUp]);
};